import React from 'react';
import BadgeTier from './SellerBadge';

/**
 * TrustedSellerBadge — thin backwards-compatible wrapper over the unified
 * `<BadgeTier tier="seller">` from SellerBadge.js.
 *
 * iter121 — shape / size / typography now matches Verified User + Trusted
 * Dealer. Shield is orange (#f97316); title is "Trusted Seller".
 * `short` prop is preserved for callers but no longer changes the label —
 * the spec requires a consistent title everywhere the badge is shown.
 */
const TrustedSellerBadge = ({ size = 'sm', testId = 'trusted-seller-badge', className }) => (
  <BadgeTier tier="seller" size={size} testId={testId} />
);

export default TrustedSellerBadge;
